import { render, staticRenderFns } from "./WalletAppendFee.vue?vue&type=template&id=b4843a9c&scoped=true&"
import script from "./WalletAppendFee.vue?vue&type=script&lang=js&"
export * from "./WalletAppendFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4843a9c",
  null
  
)

export default component.exports